module.exports = "<div class=\"services\">\n\t<div class=\"container\">\n\t\t<h2>Szolgáltatások</h2>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/services/services.component.html
// module id = ./src/app/services/services.component.html
// module chunks = 1